import { RationType } from '@/models/Ration';
import {
  getSilosShed,
  getRationTypes,
  getFeedControls,
  postFeedControl,
  deleteFeedControl,
  putFeedControl,
  getAlertById,
  postAlert,
  updateAlert,
  deleteAlert,
  getBatchHydrometry,
  getBatchHydrometryHistory,
} from '@/services/nutrition';

export const actions = {
  async sendFeedControl({ rootGetters }, data) {
    const token = rootGetters['user/getToken'];
    await postFeedControl(token.access, data);
  },
  async removeFeedControl({ rootGetters }, data) {
    const token = rootGetters['user/getToken'];
    await deleteFeedControl(token.access, data);
  },
  async editFeedControl({ rootGetters }, data) {
    const token = rootGetters['user/getToken'];
    await putFeedControl(token.access, data.id, data);
  },
  async loadSilosShed({ rootGetters, commit }, id) {
    const token = rootGetters['user/getToken'];
    const silosShed = await getSilosShed(token.access, id);
    commit('SET_SILOS_SHED_ADD_RATION', silosShed);
  },
  async loadRationTypes({ rootGetters, commit }, id) {
    const token = rootGetters['user/getToken'];
    const { results } = await getRationTypes(token.access, id);
    commit(
      'SET_RATION_TYPES',
      results.map((rationType) => RationType.fromApi(rationType))
    );
  },
  async loadFeedControls({ rootGetters, commit }, { id, params }) {
    const token = rootGetters['user/getToken'];
    return await getFeedControls(token.access, id, params);
  },
  resetNutritionValues({ commit }) {
    commit('SET_RATION_TYPES', null);
    commit('SET_NUTRITION_VALUES', null);
    commit('SET_NUTRITION_IS_LOADED', false);
  },
  openDialog({ commit }) {
    commit('SET_DIALOG_STATE', true);
  },
  dialogLoading({ commit }) {
    commit('SET_DIALOG_LOADING', true);
  },
  async loadAlerts({ rootGetters, commit }, id) {
    const token = rootGetters['user/getToken'];
    const response = await getAlertById(token.access, id);
    const alerts = response.results;
    commit('SET_ALERTS', alerts);
    return alerts;
  },
  async sendAlerts({ rootGetters }, data) {
    const token = rootGetters['user/getToken'];
    await postAlert(token.access, data);
  },
  async editAlerts({ rootGetters }, data) {
    const token = rootGetters['user/getToken'];
    await updateAlert(token.access, data.id, data);
  },
  async removeAlerts({ rootGetters }, data) {
    const token = rootGetters['user/getToken'];
    await deleteAlert(token.access, data);
  },
  async loadBatchHydrometry({ rootGetters }, batchId) {
  const token = rootGetters['user/getToken'];
  return getBatchHydrometry(token.access, batchId);
  },
  async loadBatchHydrometryHistory({ rootGetters }, { batchId, start, end }) {
  const token = rootGetters['user/getToken'];
  return getBatchHydrometryHistory(token.access, batchId, { start, end });
  },
};
